import { Component, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-interested-in-quotation',
  imports: [
    TranslatePipe
  ],
  templateUrl: './interested-in-quotation.component.html',
  styleUrl: './interested-in-quotation.component.scss'
})
export class InterestedInQuotationComponent {
  data: any = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<InterestedInQuotationComponent>);


}
